import _ from 'lodash'
import DataType from 'scoreboard/datasets/model/data-type'
const { TEXT } = DataType

/**
 * Some fields (i.e. score, weight, etc.) have a fixed dataType that must
 * be used.  This function inspects the primary dataType and the field to
 * resolve and return the correct dataType.
 *
 * @param {string} type a dataType that will either be returned or overridden
 * based on the fieldName
 * @param {string} fieldName
 * @param {string} [fieldValue]
 * @returns {*}
 */
var dataTypeResolver = function(type, fieldName, fieldValue) {
	var dataType = type
	if (fieldName === 'id') {
		// Not interpreted by formatValue, but required for exports
		dataType = TEXT
	} else if (fieldName === 'score') {
		dataType = 'score'
	} else if (fieldName === 'weight' ||
			   fieldName === 'impact' ||
			   _.endsWith(fieldName, 'Percent') ||
			   _.endsWith(_.trim(fieldValue), '%')) {
		dataType = 'percent'
	}
	return dataType

}

export default dataTypeResolver

dataTypeResolver.__filename__ = 'components/data-type-resolver.js'
